export const RESET_SURVEY = 'RESET_SURVEY'
export const SET_SURVEY = 'SET_SURVEY'
export const SET_SURVEYS = 'SET_SURVEYS'
export const SET_SURVEY_TYPES = 'SET_SURVEY_TYPES'
export const SET_INCOMPLETE_SURVEYS_COUNT = 'SET_INCOMPLETE_SURVEYS_COUNT'
export const UPDATE_INCOMPLETE_SURVEYS_COUNT = 'UPDATE_INCOMPLETE_SURVEYS_COUNT'
export const ADD_PHOTO = 'ADD_PHOTO'
export const REMOVE_PHOTO = 'REMOVE_PHOTO'
export const UPDATE_BUILDING_NOTE = 'UPDATE_BUILDING_NOTE'
export const SET_BUILDING_NOTE = 'SET_BUILDING_NOTE'



// WEBPACK FOOTER //
// ./src/store/modules/survey/types.js